import * as Styled from './DualKPIWidget.styles';
import WidgetContainer from '../../Atoms/WidgetContainer/WidgetContainer';
import { Skeleton } from '@mui/material';

const DualKPIWidgetSkeleton = ({ error }: { error?: boolean }) => {
  return (
    <WidgetContainer error={error} skeleton title='Title' maxWidth={300} maxHeight={150}>
      <Styled.KPIRow>
        <Styled.KPIColumn>
          <Skeleton>
            <Styled.KPIValue variant='h4'>1000</Styled.KPIValue>
          </Skeleton>
          <Skeleton>
            <Styled.KPIUnit variant='body1'>label</Styled.KPIUnit>
          </Skeleton>
        </Styled.KPIColumn>
        <Styled.KPIColumn>
          <Skeleton>
            <Styled.KPIValue variant='h4'>1000</Styled.KPIValue>
          </Skeleton>
          <Skeleton>
            <Styled.KPIUnit variant='body1'>label</Styled.KPIUnit>
          </Skeleton>
        </Styled.KPIColumn>
      </Styled.KPIRow>
    </WidgetContainer>
  );
};
export default DualKPIWidgetSkeleton;
